import { cn } from '@/lib/utils';
import styles from './Legend.module.css';

/**
 * An interface that represents an item in a legend.
 */
export interface LegendItem {
  label: string;
  className?: string;
}

/**
 * An interface that represents the props for the Legend component.
 */
interface LegendProps {
  legendItems: LegendItem[];
  /** Right-aligned summary, e.g. the number of people away this month. */
  trailing?: React.ReactNode;
}

/**
 * The calendar's footer legend — one swatch per leave type present in the
 * current view, with an optional right-aligned summary.
 *
 * @param legendItems - An array of objects with label and className properties.
 * @param trailing - Optional node pinned to the right edge.
 * @returns The rendered Legend component.
 */
export function Legend({ legendItems, trailing }: LegendProps) {
  return (
    <div data-tour="calendar-legend" className={styles.footer}>
      {legendItems.map(({ label, className }, i) => (
        <span key={i} className={styles.item}>
          <span
            data-type="legend-swatch"
            className={cn(styles.square, className)}
          />
          <span data-type="legend-item">{label}</span>
        </span>
      ))}

      {trailing && <span className={styles.trailing}>{trailing}</span>}
    </div>
  );
}
